/**
 * Define constants for mutations here so that there is a central store of what they are
 */
const path = 'widgets/documents';
export const SET_FILTER_LIMIT = `${path}/SET_FILTER_LIMIT`;
export const SET_DOC_TYPE = `${path}/SET_DOC_TYPE`;
export const SET_DOCUMENTS = `${path}/SET_DOCUMENTS`;
